var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pl-1"},_vm._l((_vm.treeData),function(category,key){return _c('div',{key:category.name},[_c('CategoryTreeItem',{staticClass:"item",attrs:{"db":key,"model":category}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }